import { CalendarDate } from '@internationalized/date';
import {
  UpdateInvoiceInput,
  InvoiceStatus,
  PaymentTerm,
  InvoiceLineItemInput,
  MoneyInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type InvoiceUpdateParams = {
  id: string;
  documentDate?: CalendarDate | null;
  documentNumber?: string | null;
  status?: InvoiceStatus | null;
  dueDate?: CalendarDate | null;
  paymentTerm?: PaymentTerm | null;
  notes?: string | null;
  amount?: MoneyInput | null;
  facilityId?: string | null;
  lineItems?: InvoiceLineItemInput[];
};

export const invoiceUpdateAtom = createMutationAtomFactory(
  'finance.invoiceUpdate',
  (params: InvoiceUpdateParams) => {
    const input: UpdateInvoiceInput = {};

    if (params.documentDate !== undefined) {
      input.documentDate = params.documentDate?.toString() ?? null;
    }
    if (params.documentNumber !== undefined) {
      input.documentNumber = params.documentNumber;
    }
    if (params.status !== undefined) {
      input.status = params.status;
    }
    if (params.dueDate !== undefined) {
      input.dueDate = params.dueDate?.toString() ?? null;
    }
    if (params.paymentTerm !== undefined) {
      input.paymentTerm = params.paymentTerm;
    }
    if (params.notes !== undefined) {
      input.notes = params.notes;
    }
    if (params.amount !== undefined) {
      input.amount = params.amount;
    }
    if (params.facilityId !== undefined) {
      input.facilityID = params.facilityId;
    }
    if (params.lineItems !== undefined) {
      input.lineItems = params.lineItems;
    }

    return {
      financeInvoiceUpdate: {
        __args: {
          id: params.id,
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
